import { DecorationSet } from '@codemirror/view';

import { CodeData } from '@/components/Code/Code';
import { CodeLanguageType } from '@/components/Code/types';
import { ExpandableErrorAlert } from '@/components/ExpandableErrorAlert';

interface ErrorBoundaryFallbackProps<T = unknown> {
  data: T;
  diffValues?: {
    decoration: DecorationSet;
    generatedCode: string | undefined;
  };
  onChange?: (value: T) => void;
  readOnly?: boolean;
  schema?: Record<string, unknown>;
  language?: CodeLanguageType;
  msg?: string;
}

export function ErrorBoundaryRawFallback<T = unknown>({
  data,
  diffValues,
  onChange,
  readOnly = true,
  schema,
  language = 'json',
  msg,
}: ErrorBoundaryFallbackProps<T>) {
  return (
    <div className="flex flex-col gap-4">
      <ExpandableErrorAlert error={msg} defaultOpen={false} />
      <div className="overflow-hidden rounded-lg border border-secondary">
        <CodeData
          value={data}
          diffValues={diffValues}
          onChange={onChange}
          language={language}
          schema={schema}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
}
